import type { FaireProductEntity } from "../../entity_types/product";

export const p_8woyuyox: FaireProductEntity = {
  token: "p_8woyuyox",
  type: "product",
  name: "Baby Moon Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/71ad68dd06c5a44bef481c4a051152a13958781c42c74c0f0b54200179501587/1528336478.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/fc77109231682777e0614041a49c5b1c88c5154734f4204202e1978ff695a399/1528336478.png",
    "https://cdn.faire.com/fastly/cfe8da7f6c99ec8fe920566042dd04ee2c766c481973b1d425da5a4a4b2e744b.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:09.625Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
